import { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core';
import Header from '../components/Header';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import {
  createExamAppointment,
  getDepartments,
  getMpPreference,
} from '../config/apiConfig';
import { roundOutNumber, validateEmail } from '../utils/helpers';
import { useHistory, useLocation } from 'react-router-dom';
import Notification from '../components/Notification';
import DoctariSpinner from '../components/Spinner';
import { formatNumber } from '../utils/helpers';

const useStyles = makeStyles((theme) => ({
  root: {
    '& label.Mui-focused': {
      color: '#A12457',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#A12457',
    },
    '& .Mui-focused': {
      // color: '#A12457',
    },
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: '#A12457',
    },
    '& .Mui-checked': {
      color: '#A12457',
    },
  },
  formContainer: {
    width: '50%',
    boxShadow: '0px 0px 30px -3px rgba(0,0,0,0.1)',
    borderRadius: '10px',
    padding: '30px',
    '@media(max-width:768px) ': {
      width: '85%',
    },
  },
  paymentOption: {
    borderRadius: '5px',
    margin: '0',
    boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px',
  },
  formTitle: {
    width: '50%',
    marginBottom: '10px',
    '@media(max-width:768px) ': {
      width: '85%',
    },
  },
}));

const IDENTITY_TYPES = [
  { id: 13, name: 'Cédula de identidad' },
  { id: 22, name: 'Pasaporte' },
  { id: 17, name: 'Otro documento extranjero' },
];

function PatientForm() {
  const classes = useStyles();
  const history = useHistory();
  const { search } = useLocation();
  const status = new URLSearchParams(search).get('status');
  const selectedExams = JSON.parse(localStorage.getItem('selectedExams'));
  const [patient, setPatient] = useState({
    id_type: null,
    id_number: null,
    first_name: null,
    last_name: null,
    email: null,
    telephone: null,
    date_of_birth: moment().add(-18, 'years').format('DD/MM/YYYY'),
    gender: null,
    address: null,
  });

  // to fill the property exam and combination exam it is checked if the selectedExams object has an exams property,
  // since if it does it means that it is a combination exam and if it is not an it means it is an exam object
  const appointment = {
    date: JSON.parse(localStorage.getItem('selectedDate')).start,
    departament: null,
    payment_method: 1,
    plexus_event_id: JSON.parse(localStorage.getItem('selectedDate')).EventoId,
    plexus_hour_id: JSON.parse(localStorage.getItem('selectedDate')).HoraId,
    combination_exams: selectedExams
      .filter(
        (item) => item.exam.combination === true && item.exam.exams.length > 0
      )
      .map((item) => item.exam.id),
    exams: selectedExams
      .filter((item) => item.exam.combination === false)
      .map((item) => item.exam.id),
  };

  const examPrice = (exam) => {
    if (localStorage.getItem('isSemmMember') === 'true') {
      return exam?.semm_preferential_price * 1.1;
    } else {
      return exam?.price * 1.1;
    }
  };

  const [departments, setDepartments] = useState([]);

  const [acceptTermsAndConditions, setAcceptTermsAndConditions] =
    useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const { payment_method, date } = appointment;
  const { email, date_of_birth, gender } = patient;

  const testAmount = selectedExams.price;
  const semmAmount = selectedExams.semm_preferential_price;
  const isSemmMember = localStorage.getItem('isSemmMember');
  const ivaAmount =
    isSemmMember == 'true'
      ? roundOutNumber(semmAmount * 0.1)
      : roundOutNumber(selectedExams.price * 0.1);
  const professionalBell = (140).toFixed(2);
  const totalAmount = Math.floor(
    isSemmMember == 'true'
      ? roundOutNumber(
          parseFloat(semmAmount) * 0.1 +
            parseFloat(semmAmount) +
            parseFloat(140)
        )
      : roundOutNumber(
          parseFloat(testAmount) * 0.1 +
            parseFloat(testAmount) +
            parseFloat(140)
        )
  );

  useEffect(() => {
    getDepartments().then((res) => {
      setDepartments(res.data);
    });
  }, []);

  // useEffect(() => {
  //   if (statusMessage === 'Examen agendado con éxito') {
  //     localStorage.removeItem('selectedExams');
  //     localStorage.removeItem('selectedDate');
  //     history.push('/type_exam_appointments');
  //     console.log('success');
  //   }
  // }, [statusMessage]);

  const handleCreateAppointment = (e) => {
    e.preventDefault();
    let is_semm_member = isSemmMember === 'true';
    let body = { patient, appointment, is_semm_member };
    setLoading(true);
    createExamAppointment(body)
      .then((res) => {
        if (true) {
          // if payment method is local
          setLoading(false);
          localStorage.setItem('successMessage', 'Prueba agendada con éxito');
          localStorage.removeItem('selectedExams');
          localStorage.removeItem('selectedDate');
          history.push('/type_exam_appointments');
        } else {
          const body = {
            title: '',
            price: parseInt(totalAmount),
            appointment: res.data.exam_appointment.id,
          };
          getMpPreference(body).then((resp) => {
            window.location.replace(resp.data.init_point);
          });
        }
      })
      .catch((err) => {
        localStorage.setItem('errorMessage', 'Error al crear la cita');
        setStatusMessage(
          'Error al crear la cita: verifique que los datos sean correctos'
        );
        setLoading(false);
      });
    // }
  };
  return (
    <>
      {statusMessage && (
        <Notification
          type="error"
          message={statusMessage}
          onCloseCallback={() => {
            setStatusMessage('');
            localStorage.removeItem('errorMessage');
          }}
        />
      )}
      {status && status == 'failure' && (
        <Notification
          type="error"
          message="Ocurrió un error al momento de efectuar el pago. Intente de nuevo"
          onCloseCallback={() => {
            history.push('/patient_form');
          }}
        />
      )}
      {loading && (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{
            height: '100vh',
            position: 'absolute',
            zIndex: 1000,
            top: '85px',
          }}
        >
          <DoctariSpinner />
        </Grid>
      )}
      <div style={{ opacity: loading ? '0.4' : '1' }}>
        <Header />
        <Grid
          container
          direction="column"
          // justifyContent="center"
          alignItems="center"
          style={{ marginBottom: '30px' }}
        >
          <Grid
            item
            container
            justifyContent="flex-start"
            className={classes.formTitle}
          >
            <Typography
              variant="h5"
              align="center"
              style={{ color: '#A12457', fontWeight: 'bold' }}
            >
              Crear cita
            </Typography>
          </Grid>
          <Grid item className={classes.formContainer}>
            <Grid
              container
              item
              direction="column"
              style={{ marginBottom: '20px' }}
            >
              <Grid item>
                <Typography variant="body1">
                  Fecha de la prueba:{' '}
                  <strong>
                    {moment(date, 'DD-MM-YYYY HH:mm').format(
                      'DD-MM-YYYY HH:mm'
                    )}
                    hs
                  </strong>
                </Typography>
              </Grid>
              <Grid container item>
                <Typography variant="body1">
                  Nombre de la prueba:{' '}
                  <strong>
                    {selectedExams.map((item) => item.exam.name).join(', ')}{' '}
                  </strong>
                </Typography>
              </Grid>
            </Grid>
            <form onSubmit={handleCreateAppointment}>
              <Grid
                container
                item
                direction="row"
                spacing={4}
                justifyContent="center"
              >
                <Grid item xs={12} lg={6}>
                  <TextField
                    className={classes.root}
                    placeholder="Nombre *"
                    fullWidth
                    onChange={(e) =>
                      setPatient({ ...patient, first_name: e.target.value })
                    }
                    required
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField
                    className={classes.root}
                    placeholder="Apellido *"
                    fullWidth
                    onChange={(e) =>
                      setPatient({ ...patient, last_name: e.target.value })
                    }
                    required
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  {/* <TextField label="Tipo de documento *" fullWidth /> */}
                  <Autocomplete
                    className={classes.root}
                    disablePortal
                    id="combo-box-demo"
                    options={IDENTITY_TYPES}
                    getOptionLabel={(option) => option.name || ''}
                    size="small"
                    // onChange={(event, value) => setAppointmentType(value)}
                    onChange={(_, value) => {
                      setPatient({ ...patient, id_type: value && value.id });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Tipo de documento *"
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item lg={6} xs={12}>
                  <TextField
                    className={classes.root}
                    placeholder="Número de documento *"
                    fullWidth
                    onChange={(e) =>
                      setPatient({ ...patient, id_number: e.target.value })
                    }
                    required
                  />
                </Grid>
                <Grid item lg={6} xs={12}>
                  <TextField
                    className={classes.root}
                    label="Fecha de nacimiento "
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={date_of_birth}
                    fullWidth
                    onChange={(e) =>
                      setPatient({
                        ...patient,
                        date_of_birth: moment(e.target.value).format(
                          'DD/MM/YYYY'
                        ),
                      })
                    }
                    error={
                      date_of_birth !== ''
                      // && !isOlderThan18(date_of_birth)
                    }
                    // helperText={
                    //   date_of_birth !== null &&
                    //   !isOlderThan18(date_of_birth) &&
                    //   'Tiene que ser mayor de 18 años'
                    // }
                    required
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <FormControl
                    // className={styles.formControl}
                    className={classes.root}
                    style={{
                      marginBottom: '0rem',
                    }}
                    error={gender === ''}
                    // disabled={isExistPatient}
                    fullWidth
                  >
                    <Grid container>
                      <Grid
                        container
                        item
                        xs={12}
                        xl={2}
                        justifyContent="flex-start"
                        alignItems="center"
                      >
                        <FormLabel style={{ marginBottom: '0' }}>
                          Sexo *
                        </FormLabel>
                      </Grid>
                      <Grid item xs={12} xl={10}>
                        <RadioGroup
                          aria-label="gender"
                          name="gender1"
                          onChange={(e) =>
                            // setDataPatient({ ...dataPatient, gender: e.target.value })
                            setPatient({
                              ...patient,
                              gender: e.target.value == 1 ? 'M' : 'F',
                            })
                          }
                          // value={gender}
                          row
                        >
                          <Grid
                            container
                            justifyContent="space-evenly"
                            alignItems="center"
                            style={{ marginTop: '0.32rem' }}
                          >
                            <FormControlLabel
                              value="2"
                              control={<Radio size="small" required />}
                              label={
                                <Typography style={{ marginTop: '0.2rem' }}>
                                  Femenino
                                </Typography>
                              }
                              required
                            />
                            <FormControlLabel
                              value="1"
                              control={<Radio size="small" required />}
                              label={
                                <Typography style={{ marginTop: '0.2rem' }}>
                                  Masculino
                                </Typography>
                              }
                            />
                          </Grid>
                        </RadioGroup>
                      </Grid>
                    </Grid>
                  </FormControl>
                </Grid>
                <Grid item lg={6} xs={12}>
                  <TextField
                    className={classes.root}
                    placeholder="Email *"
                    type="email"
                    fullWidth
                    onChange={(e) =>
                      setPatient({ ...patient, email: e.target.value })
                    }
                    error={email !== null && !validateEmail(email)}
                    helperText={
                      email !== null &&
                      !validateEmail(email) &&
                      'Email inválido'
                    }
                    required
                  />
                </Grid>
                <Grid item lg={6} xs={12}>
                  <TextField
                    className={classes.root}
                    placeholder="Teléfono de contacto *"
                    fullWidth
                    onChange={(e) =>
                      setPatient({ ...patient, telephone: e.target.value })
                    }
                    required
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <Autocomplete
                    className={classes.root}
                    disablePortal
                    id="combo-box-demo"
                    options={departments}
                    getOptionLabel={(option) => option.name || ''}
                    size="small"
                    onChange={(_, value) => {
                      setAppointment({
                        ...appointment,
                        departament: value && value.pk,
                      });
                      setSelectedDepartment(value);
                    }}
                    // value={appointmentType}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Departamento *"
                        required
                      />
                    )}
                  />
                </Grid> */}

                <Grid item xs={12}>
                  <TextField
                    className={classes.root}
                    placeholder="Dirección *"
                    fullWidth
                    onChange={(e) =>
                      setPatient({ ...patient, address: e.target.value })
                    }
                    required
                  />
                </Grid>

                <Grid container item xs={12} direction="column" spacing={2}>
                  <Grid item>
                    <Typography variant="body1">
                      <strong>Detalles de pago</strong>
                    </Typography>
                  </Grid>
                  <Grid container item>
                    <Grid item xs={8}>
                      <Typography variant="body2">
                        Costo de la prueba (10% de IVA inc.)
                      </Typography>
                    </Grid>
                    <Grid container item xs={4} justifyContent="flex-end">
                      <Typography variant="body2">
                        $
                        {formatNumber(
                          JSON.parse(
                            localStorage.getItem('selectedExams')
                          ).reduce((acc, item) => acc + examPrice(item.exam), 0)
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container item>
                    <Grid item xs={8}>
                      <Typography variant="body2">
                        Timbre Profesional
                      </Typography>
                    </Grid>
                    <Grid container item xs={4} justifyContent="flex-end">
                      <Typography variant="body2">
                        $
                        {formatNumber(localStorage.getItem('totalSamplePrice'))}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item style={{ padding: '0px' }}>
                    <hr />
                  </Grid>
                  <Grid container item>
                    <Grid item xs={8}>
                      <Typography variant="body2">
                        <strong>Total a Pagar</strong>
                      </Typography>
                    </Grid>
                    <Grid container item xs={4} justifyContent="flex-end">
                      <Typography variant="body2">
                        <strong>
                          $
                          {formatNumber(
                            JSON.parse(
                              localStorage.getItem('selectedExams')
                            ).reduce(
                              (acc, item) => acc + examPrice(item.exam),
                              0
                            ) +
                              parseFloat(
                                localStorage.getItem('totalSamplePrice')
                              )
                          )}
                        </strong>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container item xs={12} direction="column">
                  <Grid item>
                    <FormControl className={classes.root} fullWidth>
                      <Typography variant="body2">
                        <strong>Métodos de pago: </strong>Presencial
                      </Typography>
                      {/* <FormLabel>Métodos de pago *</FormLabel> */}
                      {/* <RadioGroup
                        aria-label="paymentMethod"
                        name="paymentMethod"
                        // value={payment_method}
                        onChange={(e) => {
                          setAppointment({
                            ...appointment,
                            payment_method: e.target.value,
                          });
                        }}
                      >
                        <FormControlLabel
                          className={classes.paymentOption}
                          value="1"
                          control={<Radio size="small" required />}
                          label="Pago presencial"
                          style={{ marginBottom: '5px' }}
                        />
                        <FormControlLabel
                          className={classes.paymentOption}
                          value="2"
                          control={<Radio size="small" required />}
                          label="Mercado Pago"
                        />
                      </RadioGroup> */}
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  style={{ padding: '16px 16px 0 16px' }}
                >
                  <Typography variant="subtitle2">
                    <strong>
                      Todos los datos ingresados en este formulario serán
                      tratados de manera confidencial y utilizados únicamente
                      para los fines para los que se proporcionan.
                    </strong>
                  </Typography>
                </Grid>
                <Grid container item xs={12} justifyContent="center">
                  <FormControlLabel
                    className={classes.root}
                    control={
                      <Checkbox
                        size="small"
                        checked={acceptTermsAndConditions}
                        onChange={() =>
                          setAcceptTermsAndConditions(!acceptTermsAndConditions)
                        }
                        name="checkedA"
                        required
                      />
                    }
                    label={
                      <Typography style={{ marginTop: '0.32rem' }}>
                        Acepto términos y condiciones
                      </Typography>
                    }
                  />
                </Grid>
                <Grid container item xs={12} justifyContent="flex-end">
                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      letterSpacing: '1.25px',
                      fontWeight: 'bold',
                      backgroundColor: '#A12457',
                      color: 'white',
                    }}
                  >
                    Aceptar
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default PatientForm;
